import * as generalActions from '../GENERAL/actions';
import * as uiActions from './actions';
import * as userActions from '../user/actions';
import { version } from '../../../package.json'; 

const initialState = {
    device: 'mobile', // either desktop or mobile
    version: version,
    redirectPath: '/', 
    isBackButtonVisible: false,
};

export const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case uiActions.SET_DEVICE:
            return {
                ...state,
                device: action.device,
            };

        case uiActions.SET_VERSION:
            return {
                ...state,
                version: action.version,
            };

        case uiActions.SET_REDIRECT_PATH:
            return {
                ...state,
                redirectPath: action.path,
            };

        case userActions.LOGIN:
            return {
                ...state,
                version: version,
            }

        case generalActions.APPLY_SEMANTIC_FILTERS:
            return {
                ...state,
                isBackButtonVisible: true,
            };

        case uiActions.HIDE_BACK_BUTTON:
            return {
                ...state,
                isBackButtonVisible: false,
            };

        case generalActions.CLEAN_PERSISTED_STORAGE:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/ui/reducer.js